import { createAsyncThunk } from '@reduxjs/toolkit'
import MediaReactions from './media-reactions-model'
import {
  delete_mediaReactions,
  load_mediaReactionss,
  store_mediaReactions,
} from './mediaReactions-service'

export const LoadMediaReactionssAsync = createAsyncThunk<any, any>(
  'composer/load/mediaReactions',
  async (params: { uid: string }) => {
    return await load_mediaReactionss(params)
  },
)

export const CreateMediaReactionsAsync = createAsyncThunk<any, any>(
  'composer/create/mediaReactions',
  async (params: MediaReactions) => {
    return await store_mediaReactions(params)
  },
)

export const DeleteMediaReactionsAsync = createAsyncThunk<any, any>(
  'composer/delete/mediaReactions',
  async (params) => {
    return await delete_mediaReactions(params)
  },
)
